<template>
  <div class="rp-ranges">
    <span class="text-muted small me-1"><i class="ti me-1" :class="icon"></i>{{ label }}</span>
    <button
      v-for="choice in choices"
      :key="choice.key"
      type="button"
      class="rp-range"
      :class="{ active: active === choice.key }"
      @click="$emit('select', choice)"
    >
      {{ choice.label }}
    </button>
  </div>
</template>

<script>
/** A row of chips above a report: quick periods, look-back days, expiry window… */
export default {
  name: 'ReportChoices',
  props: {
    label: { type: String, default: 'Period' },
    icon: { type: String, default: 'ti-calendar-event' },
    choices: { type: Array, required: true },
    active: { type: [String, Number], default: null },
  },
  emits: ['select'],
};
</script>

<style scoped src="./inventoryReport.css"></style>
